'use strict';

var Backbone = require('backbone');

class AgentModel extends Backbone.Model.extend({ idAttribute: 'uid' }) {

  defaults() {
    return {
      tags: [],
      avatar: '',
      username: '',
      job: '',
      available_mode: 'unavailable',
      is_text_capable: false,
      is_audio_capable: false,
      is_video_capable: false,
      isVideoEngineer: false
    }
  }

}

module.exports = AgentModel;



// WEBPACK FOOTER //
// ./assets/components/VideoDesk/models/agentModel.js